import { Building, Building2, Boxes, ShoppingCart, ShoppingBag, Receipt, Users,
         User, Wallet, Wrench, BarChart3, PieChart, Shield, ShieldCheck, Briefcase,
         Flag, FlaskConical, Megaphone, Layers, Target, Truck, Cog, Settings, Leaf,
         HeartPulse, Cpu, Code, Database, Cloud, Palette, Camera, Music, Book,
         GraduationCap, Scale, Gavel, Coffee, Utensils, Plane, Ship, Hammer,
         PaintBucket, Sparkles, Zap, Rocket, Award, Trophy, Star, MapPin, Globe,
         Phone, Mail, MessageCircle, Calendar, Clock, Sun, Home, Factory, Tent,
         Landmark, Store, Warehouse, Lightbulb, Compass, Anchor, Bike, Tv, Bone,
         Baby, Bell, Gift, Headphones, Film, Mic, Microscope } from "lucide-react";

// خريطة كاملة (60+ أيقونة) — كل مفتاح يعبّر عن نوع قسم شائع في الشركات.
export const DEPT_ICONS = {
  building: Building, building2: Building2, factory: Factory, home: Home, tent: Tent,
  landmark: Landmark, store: Store, warehouse: Warehouse, boxes: Boxes, cart: ShoppingCart,
  bag: ShoppingBag, receipt: Receipt, users: Users, user: User, wallet: Wallet,
  wrench: Wrench, hammer: Hammer, chart: BarChart3, pie: PieChart, shield: Shield,
  shieldCheck: ShieldCheck, briefcase: Briefcase, flag: Flag, flask: FlaskConical,
  megaphone: Megaphone, layers: Layers, target: Target, truck: Truck, ship: Ship,
  plane: Plane, bike: Bike, cog: Cog, settings: Settings, leaf: Leaf, health: HeartPulse,
  cpu: Cpu, code: Code, database: Database, cloud: Cloud, palette: Palette,
  paint: PaintBucket, camera: Camera, film: Film, tv: Tv, music: Music, mic: Mic,
  headphones: Headphones, book: Book, grad: GraduationCap, scale: Scale, gavel: Gavel,
  coffee: Coffee, food: Utensils, sparkles: Sparkles, zap: Zap, rocket: Rocket,
  award: Award, trophy: Trophy, star: Star, gift: Gift, pin: MapPin, globe: Globe,
  compass: Compass, anchor: Anchor, phone: Phone, mail: Mail, message: MessageCircle,
  calendar: Calendar, clock: Clock, sun: Sun, bell: Bell, bulb: Lightbulb,
  microscope: Microscope, bone: Bone, baby: Baby,
};

// 28 لونًا مبهجًا — من الحيوي إلى الترابي — يعمل في الوضعين الفاتح والداكن.
export const DEPT_COLORS = [
  "#ef4444", "#f97316", "#f59e0b", "#eab308", "#84cc16",
  "#22c55e", "#10b981", "#14b8a6", "#06b6d4", "#0ea5e9",
  "#3b82f6", "#6366f1", "#8b5cf6", "#a855f7", "#d946ef",
  "#ec4899", "#f43f5e", "#dc2626", "#ea580c", "#059669",
  "#0891b2", "#7c3aed", "#db2777", "#64748b", "#78716c",
  "#525252", "#166534", "#7c2d12",
];

export const DEPT_ICON_KEYS = Object.keys(DEPT_ICONS);
export const DeptIcon = ({ iconKey, className }) => {
  const Icon = DEPT_ICONS[iconKey] || Building;
  return <Icon className={className} />;
};

// اقتراحات جاهزة — تُملأ في النموذج عند النقر لتسريع إنشاء أول قسم.
export const DEPT_SUGGESTIONS = [
  { name_ar: "المخازن", name_en: "Warehouse", icon_key: "warehouse", color: "#3b82f6", code: "WH" },
  { name_ar: "المشتريات", name_en: "Purchases", icon_key: "cart", color: "#f59e0b", code: "PUR" },
  { name_ar: "المبيعات", name_en: "Sales", icon_key: "megaphone", color: "#ec4899", code: "SAL" },
  { name_ar: "الموارد البشرية", name_en: "Human Resources", icon_key: "users", color: "#10b981", code: "HR" },
  { name_ar: "المحاسبة", name_en: "Accounting", icon_key: "receipt", color: "#06b6d4", code: "ACC" },
  { name_ar: "المالية", name_en: "Finance", icon_key: "wallet", color: "#14b8a6", code: "FIN" },
  { name_ar: "تقنية المعلومات", name_en: "IT", icon_key: "cpu", color: "#8b5cf6", code: "IT" },
  { name_ar: "التسويق", name_en: "Marketing", icon_key: "target", color: "#ef4444", code: "MKT" },
  { name_ar: "الإدارة", name_en: "Administration", icon_key: "briefcase", color: "#0ea5e9", code: "ADM" },
  { name_ar: "العمليات", name_en: "Operations", icon_key: "cog", color: "#64748b", code: "OPS" },
];
